import * as _ from "lodash";
import ReactDOM from "react-dom";
import React from "react";

import PageViewChart from "./pageViewChart";
import CountryViewChart from "./countryViewChart";
import { ModelApi } from "../../api/modelApi";
import { viewerOptions } from "../../viewer";

interface AnalyticsProps {
    viewer: Autodesk.Viewing.GuiViewer3D,
}

interface AnalyticsState {
    type?: string,
    period?: string,
    data?: any[],
    fetching?: boolean
}

const periods = [
    { description: "Week", id: "0" },
    { description: "Month", id: "1" },
    { description: "Year", id: "2" }
];

const types = [
    { description: "Views per day", id: "pageViews" },
    { description: "Views per country", id: "countries" }
];

const SelectOption = props => (<option value={props.id}>{props.description}</option>);

const SelectField = (props) => {
    return <div className="form-group row">
               <label className="col-form-label col-sm-6">{props.label}</label>
               <div className="col-sm-6">
                   <select className="form-control" onChange={(e) => {
                props.callback(e.target.value);

            }}>
                       {props.values.map(v => (<SelectOption key={v.id} {...v} />))}
                   </select>
               </div>
           </div>;
}

class AnalyticsContainer extends React.Component<AnalyticsProps, AnalyticsState> {

    constructor(props) {
        super(props);
        this.state = {
            type: "pageViews",
            period: "0",
            data: null,
            fetching: false
        }
    }

    componentWillMount(): void {
        this.fetchData();
    }

    componentWillUnmount(): void {

    }

    pageUrl(): string {
        return location.pathname.replace("/sd/", "");
    }

    fetchData = async () => {
        this.setState({
            data: null,
            fetching: true
        });
        const { data } = this.state.type === "pageViews"
            ? this.combineReports(
                await ModelApi.getPageViewReport(
                viewerOptions.guid,
                this.pageUrl(),
                this.state.period),
                await ModelApi.getUniquePageVisitorReport(
                    viewerOptions.guid,
                    this.pageUrl(),
                    this.state.period))
            : this.combineReports(await ModelApi.getCountryReport(
                viewerOptions.guid,
                this.pageUrl(),
                this.state.period),
                await ModelApi.getUniqueVisitorCountryReport(
                    viewerOptions.guid,
                    this.pageUrl(),
                    this.state.period));
        this.setState({
            data: data,
            fetching: false
        });
    }

    private combineReports(viewResp, visitorResp) {
        const views = viewResp.data;
        const visitors = visitorResp.data;
        const combined = views.map((v, i) => ({
            ...v, visitorCount: visitors[i].viewCount
        }));
        return { data: combined };
    }

    onSelectPeriod = async (periodId) => {
        this.setState({period: periodId}, async () => await this.fetchData());
    }

    onSelectType = async (typeId) => {
        this.setState({ type: typeId }, async () => await this.fetchData());
    }

    render() {
        return (
            <div className="react-content" style={{ height: "80%" }}>
                <form className="container pt-3" style={{ width: "auto" }}>
                    <div className="row">
                        <div className="col">
                            <SelectField label="Chart type" values={types} callback={this.onSelectType} />
                        </div>
                        <div className="col">
                            <SelectField label="Time period" values={periods} callback={this.onSelectPeriod} />
                         </div>
                     </div>
                </form>
                {this.state.fetching && <div className="row justify-content-center"><i className="icon ion-md-hourglass wait-spinner" style={{color: "#000000"}}/></div>}
                {this.state.data && this.state.type === "pageViews" &&
                    <PageViewChart viewer={this.props.viewer} data={this.state.data} />
                }
                {this.state.data && this.state.type === "countries" &&
                    <CountryViewChart viewer={this.props.viewer} data={this.state.data} />
                }

            </div>
        );
    }

}

export class AnalyticsPanel extends Autodesk.Viewing.UI.DockingPanel {

    private viewer: Autodesk.Viewing.GuiViewer3D;

    private contentDiv: HTMLDivElement;
    private reactNode;

    constructor(viewer: Autodesk.Viewing.GuiViewer3D) {
        super(viewer.container as HTMLElement, "SmartDrawings-Panel-Analytics", "Model Analytics", null);
        this.viewer = viewer;

        this.container.classList.add("status-panel");

        this.contentDiv = document.createElement("div");
        this.contentDiv.classList.add("content");
        this.container.appendChild(this.contentDiv);
    }

    async setVisible(show: boolean) {
        super.setVisible(show);
        if (show) {
            ReactDOM.unmountComponentAtNode(this.contentDiv);
            this.reactNode = ReactDOM.render(<AnalyticsContainer viewer={this.viewer}/>, this.contentDiv);
        } else if (this.reactNode) {
            ReactDOM.unmountComponentAtNode(this.contentDiv);
            this.reactNode = null;
        }
    }

}